import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How fast do I get a quote?",
    a: "Within one business day, usually much faster. Because we quote from photos, there's no waiting on a site visit — we just look, price it, and send it back.",
  },
  {
    q: "Are your tradies insured?",
    a: "Yes — every tradie on the Snap Send Repair panel carries $20M public liability insurance and has been ID and reference checked.",
  },
  {
    q: "What jobs are too big?",
    a: "We focus on minor repairs and make-goods. If your job needs council approvals, structural work or a licensed builder (extensions, major electrical or plumbing), we'll tell you honestly and point you in the right direction.",
  },
  {
    q: "Do you service my area?",
    a: "We currently cover most Australian metro areas. Send your postcode with your request — if we can't cover you directly, we'll let you know within a day.",
  },
  {
    q: "How does payment work?",
    a: "You approve the fixed price before we book. Payment happens after the job is done and you're happy — bank transfer or card.",
  },
  {
    q: "I'm renting — will my landlord be involved?",
    a: "Only if you want them to be. Lots of renters use us for end-of-lease make-goods so their bond comes back clean. We can invoice you directly, no landlord chat needed.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-24 lg:py-32 border-b border-border">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-widest text-primary mb-3">FAQ</div>
            <h2 className="font-display text-4xl sm:text-5xl font-bold text-secondary leading-none">
              Common<br />questions.
            </h2>
            <p className="mt-6 text-muted-foreground leading-relaxed">
              Something we haven't answered? Send the question through the quote form and we'll come back to you.
            </p>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((item, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
                  <AccordionTrigger className="text-left font-display text-lg lg:text-xl font-semibold text-secondary hover:text-primary py-6 hover:no-underline">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed text-base pb-6">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
